import Table from "../../../Components/Table/Table";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import TableLoading from "../../../Components/Loader/TableLoading";

export default function MissionsTable({
  rulesData,
  accountData,
  ruleLoading,
  missionStatuses,
}) {
  const {
    target: targetStatus,
    totalDrawdown: totalDrawdownStatus,
    dailyDrawdown: dailyDrawdownStatus,
    tradeDrawdown: tradeDrawdownStatus,
    minTradingDays: minTradingDaysStatus,
    consistencyRule: consRuleStatus,
    scalpProfit: scalpProfitStatus,
  } = missionStatuses;
  const isDemo = accountData?.challenge?.challenge_type === "demo";

  return (
    <div className="w-full h-fit flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark overflow-hidden min-h-0">
      {ruleLoading ? (
        <Table
          isEnglish={[1, 2]}
          columns={[
            { key: "title", label: "عنوان" },
            { key: "current", label: "وضعیت فعلی" },
            { key: "metric", label: "معیار" },
            {
              key: "status",
              label: "وضعیت",
              render: (value) =>
                value === "passed" ? (
                  <StatusColorful
                    SVGName="tick"
                    text="تکمیل شده"
                    className="w-24"
                    color="blue"
                  />
                ) : value === "stable" ? (
                  <StatusColorful
                    SVGName="stall"
                    text="پایدار"
                    className="w-24"
                    color="green"
                  />
                ) : value === "danger" ? (
                  <StatusColorful
                    SVGName="danger"
                    text="ناپایدار"
                    className="w-24"
                    color="yellow"
                  />
                ) : value === "failed" ? (
                  <StatusColorful
                    SVGName="failed"
                    text="رد شده"
                    className="w-24"
                    color="red"
                  />
                ) : (
                  ""
                ),
            },
          ]}
          data={[]}
        />
      ) : accountData?.phase?.phase_type !== "funded" ? (
        <Table
          isEnglish={[1, 2]}
          columns={[
            { key: "title", label: "عنوان" },
            { key: "current", label: "وضعیت فعلی" },
            { key: "metric", label: "معیار" },
            {
              key: "status",
              label: "وضعیت",
              render: (value) =>
                value === "passed" ? (
                  <StatusColorful
                    SVGName="tick"
                    text="تکمیل شده"
                    className="w-24"
                    color="blue"
                  />
                ) : value === "stable" ? (
                  <StatusColorful
                    SVGName="stall"
                    text="پایدار"
                    className="w-24"
                    color="green"
                  />
                ) : value === "danger" ? (
                  <StatusColorful
                    SVGName="danger"
                    text="ناپایدار"
                    className="w-24"
                    color="yellow"
                  />
                ) : value === "failed" ? (
                  <StatusColorful
                    SVGName="failed"
                    text="رد شده"
                    className="w-24"
                    color="red"
                  />
                ) : (
                  ""
                ),
            },
          ]}
          data={[
            {
              title: "سود هدف",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.profit_target?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.profit_target?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: targetStatus,
            },
            {
              title: "حد ضرر کلی",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.max_drawdown_limit?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.max_drawdown_limit?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: totalDrawdownStatus,
            },
            {
              title: "حد ضرر روزانه",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.daily_drawdown_limit?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.daily_drawdown_limit?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: dailyDrawdownStatus,
            },
            {
              title: "حد ضرر هر معامله",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.trade_drawdown_limit?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.trade_drawdown_limit?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: tradeDrawdownStatus,
            },
            ...(!isDemo
              ? [
                  {
                    title: "حداقل روزهای معاملاتی",
                    current: (
                      <span className="inline-block [direction:rtl]">
                        {rulesData != null
                          ? `${rulesData.trading_days} روز`
                          : "۰ روز"}
                      </span>
                    ),
                    metric: (
                      <span className="inline-block [direction:rtl]">
                        {rulesData != null
                          ? `${rulesData.min_trading_days} روز`
                          : "۰ روز"}
                      </span>
                    ),
                    status: minTradingDaysStatus,
                  },
                ]
              : []),

            // ✅ Consistency rule – only if definition != null
            ...(rulesData?.rules?.consistency_rule?.definition != null
              ? [
                  {
                    title: "حداکثر سود هر روز معاملاتی از سود کل",
                    current: `${
                      Number(
                        rulesData?.rules?.consistency_rule?.current_state,
                      ).toFixed(2) || "-"
                    } %`,
                    metric: `${
                      Number(
                        rulesData?.rules?.consistency_rule?.definition,
                      ).toFixed(2) || "-"
                    } %`,
                    status: consRuleStatus,
                  },
                ]
              : []),

            // ✅ Fast scalp – only if definition != null
            ...(rulesData?.rules?.fast_scalp?.definition != null
              ? [
                  {
                    title: "مجموع سود مجاز معاملات اسکلپ",
                    current: `${
                      Number(
                        rulesData?.rules?.fast_scalp?.current_state,
                      ).toFixed(2) || "-"
                    } %`,
                    metric: `${
                      Number(rulesData?.rules?.fast_scalp?.definition).toFixed(
                        2,
                      ) || "-"
                    } %`,
                    status: scalpProfitStatus,
                  },
                ]
              : []),
          ]}
        />
      ) : (
        <Table
          isEnglish={[1, 2]}
          columns={[
            { key: "title", label: "عنوان" },
            { key: "current", label: "وضعیت فعلی" },
            { key: "metric", label: "معیار" },
            {
              key: "status",
              label: "وضعیت",
              render: (value) =>
                value === "passed" ? (
                  <StatusColorful
                    SVGName="tick"
                    text="تکمیل شده"
                    className="w-24"
                    color="blue"
                  />
                ) : value === "stable" ? (
                  <StatusColorful
                    SVGName="stall"
                    text="پایدار"
                    className="w-24"
                    color="green"
                  />
                ) : value === "danger" ? (
                  <StatusColorful
                    SVGName="danger"
                    text="ناپایدار"
                    className="w-24"
                    color="yellow"
                  />
                ) : value === "failed" ? (
                  <StatusColorful
                    SVGName="failed"
                    text="رد شده"
                    className="w-24"
                    color="red"
                  />
                ) : (
                  ""
                ),
            },
          ]}
          data={[
            {
              title: "حد ضرر کلی",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.max_drawdown_limit?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.max_drawdown_limit?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: totalDrawdownStatus,
            },
            {
              title: "حد ضرر روزانه",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.daily_drawdown_limit?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.daily_drawdown_limit?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: dailyDrawdownStatus,
            },
            {
              title: "حد ضرر هر معامله",
              current:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.trade_drawdown_limit?.current_state,
                      ).toFixed(2) || "-"
                    } %`
                  : "۰ %",
              metric:
                rulesData != null
                  ? `${
                      Number(
                        rulesData?.rules?.trade_drawdown_limit?.definition,
                      ).toFixed(2) || "-"
                    } %`
                  : "۵ %",
              status: tradeDrawdownStatus,
            },
            // ✅ Consistency rule – only if definition != null
            ...(rulesData?.rules?.consistency_rule?.definition != null
              ? [
                  {
                    title: "حداکثر سود هر روز معاملاتی از سود کل",
                    current: `${
                      Number(
                        rulesData?.rules?.consistency_rule?.current_state,
                      ).toFixed(2) || "-"
                    } %`,
                    metric: `${
                      Number(
                        rulesData?.rules?.consistency_rule?.definition,
                      ).toFixed(2) || "-"
                    } %`,
                    status: consRuleStatus,
                  },
                ]
              : []),

            // ✅ Fast scalp – only if definition != null
            ...(rulesData?.rules?.fast_scalp?.definition != null
              ? [
                  {
                    title: "مجموع سود مجاز معاملات اسکلپ",
                    current: `${
                      Number(
                        rulesData?.rules?.fast_scalp?.current_state,
                      ).toFixed(2) || "-"
                    } %`,
                    metric: `${
                      Number(rulesData?.rules?.fast_scalp?.definition).toFixed(
                        2,
                      ) || "-"
                    } %`,
                    status: scalpProfitStatus,
                  },
                ]
              : []),
          ]}
        />
      )}
      {ruleLoading && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
    </div>
  );
}
